module.exports = __webpack_public_path__ + "img/8.900b4595.jpg";